import { render } from "./CustomErrorModal.vue?vue&type=template&id=7c359d55"
import script from "./CustomErrorModal.vue?vue&type=script&lang=js"
export * from "./CustomErrorModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__